import styles from './Card.scss';
import React from 'react';

const Card = ({ title, actionButton, buttonType, action, statusMessage, statusIcon }) => {

    return (
        <div className={styles.card}>
            <div className={styles.cardHeader}>
                <h2 className={styles.cardTitle}>{title}</h2>
                <div className={styles.cardStatusContainer}>
                    <span className={styles.statusIcon}>{statusIcon && statusIcon}</span>
                    <p className={styles.cardStatus}>{statusMessage}</p>
                </div>
            </div>
            <div className={styles.cardFooter}>
                {buttonType === "primary" && (
                    <button className={styles.btnPrimary} onClick={action}>
                        {actionButton}
                    </button>
                )}
                {buttonType === "secondary" && (
                    <button className={styles.btnSecondary} onClick={action}>
                        {actionButton}
                    </button>
                )}
            </div>
        </div>
    );
};

export default Card;
